export default {
    'name' : 'Page Speed',
	'menu': {
		'dashboard': 'Home',
		'pricing': 'Pricing',
		'support': 'Support',
		'get_help': 'Get Help',
		'settings': 'Settings',
        'actual_speed': 'Actual Speed',
        'perceived_speed': 'Perceived Speed',
        'tutorials': 'Tutorials',
		'optimize': 'Optimize',
		'preloading': 'Preloading',
		'loading_screen': 'Loading Screen',
        'swift_expert': 'FireApps Experts',
        'boost_sales': 'Boost Sales',
        'ali_reviews': 'Collect & Show Reviews',
        'transcy': 'Language & Currency',
        'messent': 'SMS Marketing',
        'chatalyst': 'Live Chat',
        'sales_box': 'Product Shipping Info'
    },
    'buttons': {
		'cancel': 'Cancel',
		'close': 'Close',
        'save': 'Save',
		'done': 'Done',
		'optimize': 'Optimize now',
        'restore': 'Restore',
        'stop': 'Stop',
        'refresh': 'Refresh',
        'buy_now': 'Buy now',
        'let_start': "Let's start",
        'learn_more': 'Learn more',
        'buy_more_images': 'Buy more images',
        'later': 'Later',
        'start_trial': 'Start trial now',
        'select_plan': 'Select Plan',
        'upgrade_now': 'Upgrade now',
        'try_free': 'Try function for 14 days',
		'maybe_later': 'Maybe later',
        'set_up_now': 'Set up now',
        'upgrade_plan': 'Upgrade plan',
        'set_up': 'Set up',
        'rate_us': 'Rate us',
        'talk_to_us': 'Talk To Us',
        'rate_on_shopify': 'Rate Us On Shopify',
        'subscribe_now': 'Subscribe now',
        'contact_us': 'Contact us',
        'save_it': 'Save it',
        'discover_here': 'Discover here'
    },
	'components': {
		'reviews': 'reviews',
		'tab_empty': 'There is no data',
		'drop_image': 'Or drop image to upload',
		'allowed_file': 'Allowed Formats: jpeg, gif and png (maximum {megabyte} MB)',
		'cannot_upload_image': 'The photo may not be greater than {megabyte} MB',
		'save_successfully': 'Changes saved successfully.',
		'unsaved_changes': 'You have unsaved changes.',
		'save_settings': 'Saving your changes...',
		'missing_required_fields': 'Unable to save. Please fill in all required fields.',
		'not_found': 'Not found',
        'select': 'Select',
        'quick_tutorial': 'Explore Perceived Speed',
        'tutorial_description': 'Use our premium features for free in 14 days',
        'optimize_image': 'Optimize images',
        'found': 'Founded',
        'images': 'images',
        'potential_saving': 'Potential saving',
        'optimize_your_first': '* We will optimize your first {num} images, then you can continue in our app',
        'optimize_description': '* Image links will change after being optimized. Please replace the old links with the new ones if you have set them in your ads',
        'optimize_description_two': '* Make sure to backup all images + check images carefully after optimization. Currently Shopify has a big limitation on images. <a class="a-link fz-14" href="{link}" target="_blank">Learn more</a>',
        'optimize_theme': 'Optimize theme',
        'how_these_technologies': "how these technologies improve your store's speed",
        'choose_at_least_one_method': 'Please choose at least 1 method to continue',
        'choose_at_least_one_theme': 'Please choose at least 1 theme technique to continue',
        'lazy_load_images': 'Lazyload images',
        'preload_web_fonts': 'Preload web fonts',
        'minify_css_files': 'Minify CSS files',
        'minify_javascript_files': 'Minify Javascript files',
        'extract_critical_css': 'Extract critical CSS',
        'affiliate_title': 'Let’s take a look at why site speed is so important, how site speed will become a key to making your store success',
		'buttons':{
			'add_image': 'Add image',
			'delete': 'Delete',
            'add': 'Add'
		}
	},
	'confirm': {
		'route_leave': {
			'title': 'Discard Changes',
			'content': 'The changes won\'t be saved. Do you want to leave this page?',
			'ok_text': 'Discard',
			'cancel_text': 'Cancel'
		},
		'change_setting': {
			'title': 'Unsaved changes',
			'content': 'Do you want to save current settings?',
			'ok_text': 'Yes',
			'cancel_text': 'No'
		},
		'default': {
			'ok': 'Ok',
			'cancel': 'Cancel'
		},
		'product': {
			'later': 'Later',
			'publish_now': 'Publish now'
		}
	},
	'header': {
		'your_account': 'Your account',
		'go_to_store': 'Go to store',
		'back_to_shopify': 'Back to Shopify',
		'logout': 'Logout',
		'rate_us': 'Rate us'
    },
    'trial_premium_feature': {
        'in_premium_plan': "You're in Perceived Speed trial",
        'trial_end_in': 'Your trial will end in <strong>{time}</strong>.',
        'block_title': 'Your Perceived Trial has ended!',
        'block_description': "Don't let your user waits! Upgrade to Premium Speed<br>to keep your user feeling faster with Preloading and Loading Screen."
    },
    'available_images': {
        'description': 'The number of images left you can optimize. You will have 1000 free images per month.',
        'title': 'Available Image',
        'update_success': 'Update Successfully'
    },
    'rate_us': {
        'enjoy_swift': 'Are you enjoying Swift?',
        'enjoy_description': 'Our team celebrates every rating we receive. These ratings fuel our passion and better our product.',
        'keep_improving': 'We will keep improving',
        'improving_description_one': 'Our Customer Support team is eager to help. It’ll be great if you return and rate us again once the problems have been resolved.',
        'improving_description_two': "Talk to us about any issues and we'll fix them. We'd also appreciate it if you could rate Swift on Shopify too.",
        'done_rate_title': 'You’ve just made our day',
        'done_rate_description': 'Your rating motivates us to make Swift even better in the future.'
    },
    'subscribe_image': {
        'title': 'Subscribe your plan',
        'description': 'You will have <strong>1000 free images</strong> when you subscribe now.<br>Or you can continue to buy more image to optimize.'
    },
    'modal': {
        'purchase_sucessfully': 'Purchase successfully',
        'purchase_sucess_description': 'You have purchased <strong>{num}</strong> images successfully, you can continue to optimize and speed up your store.'
    },
    'columns': {
        'image': 'Image',
        'type': 'Type',
        'status': 'Status', 
		'original_size': 'Original Size',
		'optimized_size': 'Optimized Size',
		'savings': 'Savings',
        'method': 'Method',
        'files': 'Files'
    },
    'block_function': {
        'title': 'Not available for your current plan',
        'perceived_lock_description': 'Get 100% power of speed by upgrading Premium to unlock<br>Perceived Speed',
        'actual_lock_description': 'Upgrade to Premium plan to unlock Actual Speed and get 100% power of speed',
        'header_description': 'Predict customers’ next page and download its content in advance'
	},
	'tooltip_sidebar': {
		'Preloading': {
			'content': 'Set up <strong>Preloading</strong> to increase page loading speed up to 3s'
		},
		'LoadingScreen': {
			'content': 'Set up <strong>Loading Screen</strong> to boost customer’s experience '
		},
		'PerceivedSpeed': {
			'title': 'Set up Perceived Speed',
			'content': 'Perceived Speed is how fast your customers think your site is. Explore tactics to boost user experience here.',
			'content_plan_actual': 'Perceived Speed is how fast your customers think your site is, not measured by speed metrics.',
			'lear_more': 'Learn more',
			'got_it': 'Got it'
		},
		'OptimizeImage': {
			'title': 'Actual Speed',
			'content': '<strong>Access</strong> and <strong>manage</strong> everything you need for your <strong>Theme</strong> and <strong>Image</strong> right here',
			'next': 'Next',
		}
    },
    'errors': {
        'title': 'Error',
        'description': 'Something went wrong',
        'theme_error': "Can not duplicate theme, please shorten your theme name to below 25 characters including space",
        'theme_limit_20': 'Can not duplicate theme, you reached limit of 20 themes in your library, please remove unused ones for our space',
        'theme_fail': 'Please try again or contact our support for help.',
        'something_went_wrong': 'Something went wrong'
    },
    'rating_bar': {
        'title': 'Hey {first_name}, your feedback is the best way to make Swift even better! How was your experience with us?',
        'reason_1': 'Break my theme',
        'reason_2': 'Not performing well after optimization',
        'reason_3': 'Hard to use',
        'reason_4': "Bad customer service",
        'other_placeholder': 'Let us know what happened',
        'thanks_feedback': 'Thank you for your feeback!',
        'thanks_feedback_description': 'For further support, please contact our Customer Service team.',
        'bad_feedback_title': 'Your feedback matters to us!',
        'bad_feedback_desc': 'Our team value all your feedback and take it into<br>consideration to provide you a better experience.',
        'reason_title': 'I had bad experience with Swift because:'
    }
}
